import styled from 'styled-components';

export const SelectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .main-label {
    font-size: 14px;
    font-weight: 700;
    color: #444;
  }

  .react-select__control {
    height: 50px !important;
    min-height: 50px !important;
    max-height: 50px !important;
    border: 1px solid #dcdce6 !important;
    border-radius: 5px !important;
    box-shadow: none !important;
    cursor: pointer;

    &:hover {
      border-color: #dcdce6 !important;
    }
  }

  .react-select__value-container {
    padding: 0 15px !important;
    height: 48px !important;
    display: flex !important;
    align-items: center !important;
    color: #333;
    font-size: 14px;
    overflow: hidden !important;
    cursor: pointer;
  }

  .select-all-header {
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid #eee;
    background-color: #fafafa;
    cursor: pointer;
    font-weight: 500;
    color: #333;
    transition: background 0.2s;

    &:hover {
      background-color: #f0f2f5;
    }

    input[type="checkbox"] {
      width: 16px;
      height: 16px;
      cursor: pointer;
      margin: 0;
    }

    span {
      font-size: 13px;
    }
  }

  .react-select__menu {
    z-index: 1000 !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }

  .react-select__option {
    display: flex !important;
    align-items: center !important;
    gap: 8px;
    padding: 8px 12px !important;
    background-color: transparent !important;
    color: #333 !important;
    cursor: pointer !important;

    &:hover {
      background-color: #f5f5f9 !important;
    }
    
    &--is-focused {
      background-color: #f5f5f9 !important;
    }
    
    &--is-selected {
      background-color: #e8f5e9 !important;
    }

    input[type="checkbox"] {
      width: 16px;
      height: 16px;
      cursor: pointer;
      margin: 0;
    }

    label {
      margin: 0;
      cursor: pointer;
      flex: 1;
      font-size: 14px;
    }
  }

  .react-select__indicators-container {
    height: 48px !important;
  }

  .react-select__indicator {
    padding: 8px !important;
  }
`;